/**
 * `PublicLayout` — shell pubblica usata FUORI dall'app autenticata.
 *
 * Replica la struttura visiva della `Layout` (stesso `app-shell`, stesso header
 * `navbar`) così le pagine pubbliche hanno lo stesso stile del resto
 * dell'applicazione, ma SENZA alcuna navigazione: niente `SectionSwitcher`,
 * niente link di sezione, niente `UserMenu`, niente toggle mobile.
 *
 * Il brand nell'header è un link alla root del sito (`<a href="/">`, cursore a
 * mano). Usiamo un anchor nativo (non il `Link` di react-router) così punta
 * davvero alla radice del sito e funziona anche senza sessione. Non importiamo
 * `Navbar` né `useAuth`, così questo shell funziona senza autenticazione.
 *
 * Il footer pubblico è INLINE (non riusa il `Footer` globale): mostra solo il
 * blocco legale (copyright + P.IVA) e l'attribuzione "Powered by appfactory",
 * OMETTENDO volutamente la versione dell'app e il link al Changelog, che non
 * hanno senso per un utente end-user non autenticato.
 */
import type { ReactNode } from 'react';

/**
 * `PublicLayout` — shell pubblica minimale usata FUORI dall'app autenticata.
 *
 * A differenza della `Layout` autenticata, NON mostra navbar né footer: la
 * pagina pubblica è pensata come una landing pulita, con il contenuto
 * centrato verticalmente nella viewport e un discreto "Powered by skillfactory" in
 * basso, sotto il form. `AuthProvider` resta montato (in `main.tsx`), ma qui
 * non c'è alcuna navigazione né dipendenza dall'autenticazione.
 */
export function PublicLayout({ children }: { children: ReactNode }) {
  return (
    <div className="public-shell">
      {/* Contenuto centrato verticalmente. */}
      <main className="public-shell__main">{children}</main>

      {/* Attribuzione discreta in basso: stesso logo usato nella navbar. */}
      <footer className="public-shell__powered">
        <span className="public-shell__powered-label">Powered by</span>
        <img
          className="public-shell__powered-logo"
          src="/imgs/logo.png"
          alt="skillfactory"
        />
      </footer>
    </div>
  );
}
